import { render } from "./AlertsSubMenuWide.vue?vue&type=template&id=1e658b16"
import script from "./AlertsSubMenuWide.vue?vue&type=script&lang=js"
export * from "./AlertsSubMenuWide.vue?vue&type=script&lang=js"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__